(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["look-pin"] && !Shopify.designMode) return;
  try {
    /*
    Eén pin open tegelijk: een tweede kaartje openen sluit het eerste, anders
    stapelen ze op boven een drukke foto. Klikken buiten alle pins, of Escape,
    sluit de openstaande.

    De kantel-classes komen pas ná het openen tot stand — pas dan is er iets om
    te meten. `getBoundingClientRect` t.o.v. het beeld eromheen bepaalt of het
    kaartje anders buiten links, rechts of boven het beeld zou vallen.

    Het in- en uitschuiven zit in CSS, gestuurd door `data-open`. `hidden`
    blijft ernaast bestaan voor toetsenbord en schermlezers — een dichtgedraaid
    kaartje mag niet focusbaar zijn — maar wordt pas ná de overgang gezet, niet
    er middenin, anders springt het kaartje weg voordat het kan wegschuiven.
  */
  const LOOK_PIN_DURATION = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200;

  function closeLookPin(pin) {
    const toggle = pin.querySelector('[data-look-pin-toggle]');
    const card = pin.querySelector('[data-look-pin-card]');
    if (!pin.hasAttribute('data-open')) return;

    pin.removeAttribute('data-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    window.setTimeout(() => {
      if (pin.hasAttribute('data-open') || !card) return;
      card.hidden = true;
      pin.removeAttribute('data-flip-x');
      pin.removeAttribute('data-flip-y');
    }, LOOK_PIN_DURATION);
  }

  function openLookPin(pin) {
    document.querySelectorAll('[data-look-pin][data-open]').forEach((open) => {
      if (open !== pin) closeLookPin(open);
    });

    const toggle = pin.querySelector('[data-look-pin-toggle]');
    const card = pin.querySelector('[data-look-pin-card]');
    if (!card) return;

    card.hidden = false;
    if (toggle) toggle.setAttribute('aria-expanded', 'true');

    const bounds = card.getBoundingClientRect();
    const container = pin.closest('.look-image') || document.body;
    const containerBounds = container.getBoundingClientRect();

    if (bounds.top < containerBounds.top) pin.setAttribute('data-flip-y', '');
    if (bounds.right > containerBounds.right || bounds.left < containerBounds.left) {
      pin.setAttribute('data-flip-x', '');
    }

    // Twee beeldwissels wachten: de gesloten stand moet één keer getekend zijn
    // voordat `data-open` de overgang naar open in gang zet.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        pin.setAttribute('data-open', '');
      });
    });
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-look-pin-toggle]');
    if (toggle) {
      const pin = toggle.closest('[data-look-pin]');
      if (pin.hasAttribute('data-open')) {
        closeLookPin(pin);
      } else {
        openLookPin(pin);
      }
      return;
    }

    if (!event.target.closest('[data-look-pin]')) {
      document.querySelectorAll('[data-look-pin][data-open]').forEach(closeLookPin);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-look-pin][data-open]').forEach(closeLookPin);
  });
  } catch(e) { console.error(e); }
})();

})();
